import "@google/model-viewer/dist/model-viewer.min.js";
import { Typography } from "@material-ui/core";
import { Check, LinearScaleTwoTone, ThreeSixty } from "@material-ui/icons";
import React, { Component } from "react";
import share from "../../Assets/Images/sharebtn.png";
import vecto from "../../Assets/Images/vecto.png";
import searching from "../../Assets/Images/searching.png";
import arimage from "../../Assets/Images/ar_icon.png";
import closeIcon from "../../Assets/Images/cancelToggle.png";
import { API } from "../../Constants/APIs";
import { Navigate } from "react-router-dom";
import Geocode from "react-geocode";
import { Beforeunload } from "react-beforeunload";
import closeModal from "../../Assets/Images/closeModal.png";
import Modal from "react-awesome-modal";
import axios from "axios";
import { createRef } from "react";
// import Drawer from "./Drawer";
// import ContentStyleWrapper from "./ContentStyleWrapper";
import AnnotationBtns from "../AnnotationBtns";

import HotspotContentDrawer from "../HotspotContentDrawer";
import VariantComponents from "./VariantComponents";
import { fullHeightSupport } from "../../Helpers/fullHeight";
var pageVisibility = document.visibilityState;
const variantControllerHeight = 126;
const getProductIdFromPath = () =>
  window.location.pathname.split("/").filter(Boolean).pop();
const isLocationMapViewer = () =>
  window.location.pathname.startsWith("/location-map/modelDynamicviewer/");
export default class MobileModelDynamicViewer extends Component {
  constructor(props) {
    super(props);

    this.modelRef = createRef();
    this.annotBtnCloseCB = createRef();
    this.currentModelElement = null;

    this.state = {
      showHotspot: {
        isTrue: false,
        data: {},
      },
      toggle: false,
      navClose: { right: "0px" },
      redirect: false,
      leftModels: false,
      leftDays: false,
      leftViews: false,
      productId: getProductIdFromPath(),

      // for geolocation
      lat: 0,
      long: 0,
      mobile: false,
      platform: "",
      city: "",
      country: "",
      ip: "",
      session: 0,
      count: 0,
      count1: 0,
      seconds: 0,
      checkCall: false,
      referrer: "",
      isModelLoading: true,
    };
  }

  toggleMenu = () => {
    this.setState({
      toggle: true,
    });
  };

  componentDidMount() {
    this.props.ViewModal();
    // window.addEventListener("blur", () => {
    //   this.postMobileAnalytics();
    // });

    const referrer = document.referrer;
    // const referrer ="https://admin.actuality.live/admin/analytics/624d87e3cc0658544fec4425"
    if (referrer.length > 0) {
      let domain = referrer.split("/");
      domain = domain[0] + "//" + domain[2];
      // console.log(domain);
      this.setState({ referrer: domain }, () => {
        this.props.updateMobilePayload(this.state);
      });
      // console.log( referrer);
    } else {
      this.setState({ referrer: "N/A" }, () => {
        this.props.updateMobilePayload(this.state);
      });
    }
    // window.onbeforeunload = function(e) {
    //   // this.postAnalytics();
    //   // return;
    //   // if( queue not empty ) {
    //   //   return;
    //   // }
    //   var dialogText = 'Dialog text here';
    //   e.returnValue = dialogText;
    //   return dialogText;
    // };

    // console.log(this.props);
    let modelsLeft = this.props.leftModels;
    let daysLeft = this.props.leftDays;
    let viewsLeft = this.props.leftViews;
    if (modelsLeft === 0) {
      this.setState({
        redirect: true,
        leftModels: true,
      });
    } else if (daysLeft === 0) {
      this.setState({
        redirect: true,
        leftDays: true,
      });
    } else if (viewsLeft === 0) {
      this.setState({
        redirect: true,
        leftViews: true,
      });
    }

    this.geolocationData();
    this.getIPadd();
    // window.addEventListener("focus", this.onFocus);

    // document.addEventListener("click", () => {
    //   this.setState({ count: this.state.count + 1 }, () => {
    //   //    console.log(this.state.count);
    //   });
    // });

    this.interval = setInterval(() => {
      this.setState(
        {
          seconds: this.state.seconds + 1,
        },
        () => {
          this.props.updateMobilePayload(this.state);
        },
      );
    }, 1000);

    this.attachModelLoadListener();
  }
  // setUpModal = () => {
  //   var ModalView = document.querySelector("#model-viewer");
  //   ModalView.addEventListener("ar-status", (event) => {
  //   //    console.log("checkAR_status", event);
  //     if (event.detail.status === "failed") {
  //       const error = document.querySelector("#error");
  //       this.setState({ showError: true });
  //       error.classList.remove("hide");
  //       error.addEventListener("transitionend", (event) => {
  //         error.classList.add("hide");
  //       });
  //     }
  //   });
  // };
  componentWillUnmount() {
    // console.log("unmount");
    // window.removeEventListener("focus", this.onFocus);
    this.detachModelLoadListener();
  }

  handleModelLoad = () => {
    this.setState({ isModelLoading: false });
  };

  componentDidUpdate(prevProps) {
    const previousModelSrc =
      prevProps.combination?.variant?.model_file_url ||
      (prevProps.showVariant
        ? prevProps.selectedVariant?.model_file_url
        : prevProps.model);
    const currentModelSrc =
      this.props.combination?.variant?.model_file_url ||
      (this.props.showVariant
        ? this.props.selectedVariant?.model_file_url
        : this.props.model);

    if (previousModelSrc !== currentModelSrc) {
      this.setState({ isModelLoading: true });
      this.attachModelLoadListener();
    }
  }

  setModelElementRef = (elem) => {
    this.modelRef.current = elem;
    this.currentModelElement = elem;
    this.attachModelLoadListener();
  };

  attachModelLoadListener = () => {
    const modelElement = this.currentModelElement || this.modelRef.current;
    if (!modelElement || modelElement.__actualityLoadBound) {
      return;
    }

    modelElement.addEventListener("load", this.handleModelLoad);
    modelElement.__actualityLoadBound = true;
  };

  detachModelLoadListener = () => {
    const modelElement = this.currentModelElement || this.modelRef.current;
    if (!modelElement || !modelElement.__actualityLoadBound) {
      return;
    }

    modelElement.removeEventListener("load", this.handleModelLoad);
    delete modelElement.__actualityLoadBound;
  };

  // onFocus = () => {
  //   this.geolocationData();
  //   this.getIPadd();
  //   this.setState({checkCall: true}, ()=>{
  //   //    console.log("called");
  //   });
  //   // setTimeout(() => {
  //   // this.setState({checkCall: false});
  //   // }, 100);
  // };

  componentWillMount() {
    if (window.innerWidth < 750) {
      this.setState({ navClose: { right: "-370px" } });
    }
    if (window.innerWidth < 1199) {
      this.setState({ navClose: { right: "-770px" } });
    }
  }

  getIPadd = () => {
    axios
      .get("https://api.ipregistry.co/?key=uuxgl20sk80ku9fg")
      .then((resp) => {
        // console.log(resp);
        this.setState(
          {
            ip: resp.data.ip,
            platform: resp.data.user_agent.os.name,
            mobile: resp.data.user_agent.os.type === "mobile" ? true : false,
          },
          () => {
            this.props.updateMobilePayload(this.state);

            // console.log(this.state.ip, this.state.platform, this.state.mobile);
          },
        );
      })
      .catch((err) => {
        if (err) {
          // console.log(err.response);
        }
      });
  };

  geolocationData = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        this.getlocation,
        this.showError,
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  getlocation = (data) => {
    // console.log(data);
    let platformData = navigator;
    // console.log(platformData);
    this.setState(
      {
        lat: data.coords.latitude,
        long: data.coords.longitude,
        // mobile: platformData.userAgentData.mobile,
        // platform: platformData.userAgentData.platform,
      },
      () => {
        this.props.updateMobilePayload(this.state);
        // console.log(
        //   this.state.lat,
        //   this.state.long
        //   // this.state.mobile,
        //   // this.state.platform
        // );
        this.getCountryCityName(this.state.lat, this.state.long);
      },
    );
  };

  showError = (error) => {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        // console.log("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
        // console.log("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        // console.log("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        // console.log("An unknown error occurred.");
        break;
    }
  };

  getCountryCityName = (lat, long) => {
    Geocode.setApiKey("AIzaSyDA30l6vrlZw3uCP9nQnzntysJU1U092F0");
    Geocode.setLanguage("en");
    Geocode.setRegion("es");
    Geocode.setLocationType("ROOFTOP");
    Geocode.enableDebug();

    Geocode.fromLatLng(lat, long).then(
      (response) => {
        // console.log(response);
        const address = response.results[0].formatted_address;
        let city, state, country;
        for (
          let i = 0;
          i < response.results[0].address_components.length;
          i++
        ) {
          for (
            let j = 0;
            j < response.results[0].address_components[i].types.length;
            j++
          ) {
            switch (response.results[0].address_components[i].types[j]) {
              case "locality":
                city = response.results[0].address_components[i].long_name;
                break;
              case "administrative_area_level_1":
                state = response.results[0].address_components[i].long_name;
                break;
              case "country":
                country = response.results[0].address_components[i].long_name;
                break;
            }
          }
        }
        // console.log(city, state, country);
        // console.log(address);
        this.setState(
          {
            city,
            country,
          },
          () => {
            this.props.updateMobilePayload(this.state);

            // console.log(this.state.city, this.state.country);
          },
        );
      },
      (error) => {
        console.error(error);
      },
    );
  };

  postMobileAnalytics = () => {
    let payLoadData = {
      product: this.state.productId,
      lat: this.state.lat,
      long: this.state.long,
      country: this.state.country,
      city: this.state.city,
      mobile: this.state.mobile,
      platform: this.state.platform,
      ip: this.state.ip,
      actionClicks: this.state.count,
      spaceClicks: this.state.count1,
      session: this.state.seconds,
      referrerBySession: this.state.referrer,
    };
    axios
      .post(API.postUrls.addAnalytics, payLoadData)
      .then((resp) => {
        // console.log(resp);
        // alert("post");
      })
      .catch((error) => {
        if (error) {
          // console.log(error.response);
        }
      });
  };

  openNav() {
    this.setState({ navClose: { right: "0px" }, openMainScreen: true });
  }
  closeNav() {
    this.setState({ navClose: { right: "-770px" } });
  }

  redirectToUrl = () => {
    if (this.props.UrlDescription) {
      window.open(this.props.UrlDescription);
    }
  };

  render() {
    const combination = this.props.combination;
    if (this.state.redirect === true) {
      return (
        <Navigate
          to="../pageNotFound"
          state={{
            cancelled: this.state.cancelled,
            leftModels: this.state.leftModels,
            leftDays: this.state.leftDays,
            leftViews: this.state.leftViews,
          }}
        />
      );
    } else {
      const props = this.props;

      return (
        <div
          className="mobileResponsiveViewer"
          style={{
            height: "100%",
            boxSizing: "border-box",
            border: "0px solid red",
            position: "relative",
            ...fullHeightSupport(this.props.isMdOrDown),
          }}
        >
          <HotspotContentDrawer
            open={this.state.showHotspot.isTrue}
            onClose={() => {
              this.setState({
                showHotspot: { isTrue: false, data: {} },
              });
              this.annotBtnCloseCB.current();
              this.annotBtnCloseCB.current = null;
            }}
            title={this.state.showHotspot.data.title}
            description={this.state.showHotspot.data.description}
          />
          {props.selectedVariant.usdz_file_url ? (
            <div
              style={{
                position: "relative",
                width: "100vw",
                height: window.innerHeight - variantControllerHeight - 40,
              }}
            >
              <model-viewer
                tone-mapping="aces"
                ref={this.setModelElementRef}
                id="model-viewer"
                src={
                  combination?.variant?.model_file_url
                    ? API.imgUrl + combination?.variant?.model_file_url
                    : props.showVariant
                      ? API.imgUrl + props.selectedVariant.model_file_url
                      : API.imgUrl + props.model
                }
                ios-src={
                  combination?.variant?.usdz_file_url
                    ? API.imgUrl + combination?.variant?.usdz_file_url
                    : API.imgUrl + props.selectedVariant.usdz_file_url
                }
                camera-controls
                ar
                ar-modes="webxr scene-viewer quick-look"
                ar-scale="auto"
                ar-placement={props.arplacement}
                autoplay
                touch-action={"pan-y"}
                loading="eager"
                style={{
                  background: "#FFFFFF",
                  height: window.innerHeight - variantControllerHeight - 40,
                  width: "100vw",
                }}
              >
                <AnnotationBtns
                  annots={this.props?.selectedVariant?.hotspots}
                  openHotspotDrawer={(annot, cb) => {
                    this.annotBtnCloseCB?.current?.();
                    this.annotBtnCloseCB.current = cb;
                    this.modelRef.current.setAttribute(
                      "camera-target",
                      annot.cameraTarget,
                    );
                    this.modelRef.current.setAttribute(
                      "camera-orbit",
                      annot.cameraOrbit,
                    );
                    this.modelRef.current.setAttribute(
                      "zoom",
                      annot?.zoom || 12,
                    );
                    this.setState({
                      showHotspot: {
                        isTrue: true,
                        data: {
                          title: annot.title,
                          description: annot.description,
                        },
                      },
                    });
                  }}
                />
                <button
                  slot="ar-button"
                  className="viewInYourSpace"
                  style={{
                    bottom: 0,
                    transform: "translate(-50%,50%) ",
                  }}
                  onClick={() => {
                    this.setState(
                      {
                        checkCall: true,
                        count1: this.state.count1 + 1,
                      },
                      () => {
                        this.props.updateMobilePayload(this.state);
                      },
                    );
                  }}
                >
                  <img src={arimage} width="20px" alt="" />
                  <p className="view_space_btn">
                    {" "}
                    {this.props.language === "French"
                      ? "Voir dans votre espace"
                      : "View in your space"}
                  </p>
                </button>
              </model-viewer>
              {window.location.pathname.startsWith(
                "/location-map/modelDynamicviewer/",
              ) && this.state.isModelLoading ? (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(255,255,255,0.92)",
                    zIndex: 4,
                  }}
                >
                  <div
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      border: "5px solid rgba(46,163,224,0.22)",
                      borderTopColor: "#2ea3e0",
                      animation: "actuality-map-spin 0.8s linear infinite",
                    }}
                  />
                </div>
              ) : null}
            </div>
          ) : (
            <div
              style={{
                position: "relative",
                width: "100vw",
                height: window.innerHeight - variantControllerHeight - 40,
              }}
            >
              <model-viewer
                tone-mapping="aces"
                ref={this.setModelElementRef}
                touch-action="pan-y"
                id="model-viewer"
                src={
                  combination?.variant?.model_file_url
                    ? API.imgUrl + combination?.variant?.model_file_url
                    : props.showVariant
                      ? API.imgUrl + props.selectedVariant.model_file_url
                      : API.imgUrl + props.model
                }
                camera-controls
                ar
                ar-modes="webxr scene-viewer quick-look"
                ar-scale="auto"
                ar-placement={props.arplacement}
                autoplay
                loading="eager"
                style={{
                  background: "#FFFFFF",
                  height: window.innerHeight - variantControllerHeight - 40,
                  width: "100vw",
                }}
              >
                <AnnotationBtns
                  annots={this.props?.selectedVariant?.hotspots}
                  openHotspotDrawer={(annot, cb) => {
                    this.annotBtnCloseCB?.current?.();
                    this.annotBtnCloseCB.current = cb;
                    this.modelRef.current.setAttribute(
                      "camera-target",
                      annot.cameraTarget,
                    );
                    this.modelRef.current.setAttribute(
                      "camera-orbit",
                      annot.cameraOrbit,
                    );
                    this.modelRef.current.setAttribute(
                      "zoom",
                      annot?.zoom || 12,
                    );
                    this.setState({
                      showHotspot: {
                        isTrue: true,
                        data: {
                          title: annot.title,
                          description: annot.description,
                        },
                      },
                    });
                  }}
                />
                <button
                  slot="ar-button"
                  className="viewInYourSpace"
                  style={{
                    bottom: 0,
                    transform: "translate(-50%,50%) ",
                  }}
                  onClick={() => {
                    this.setState(
                      {
                        checkCall: true,
                        count1: this.state.count1 + 1,
                      },
                      () => {
                        this.props.updateMobilePayload(this.state);
                      },
                    );
                  }}
                >
                  <img src={arimage} width="20px" alt="" />
                  <p className="view_space_btn">
                    {this.props.language === "French"
                      ? "Voir dans votre espace"
                      : "View in your space"}
                  </p>
                </button>
              </model-viewer>
              {window.location.pathname.startsWith(
                "/location-map/modelDynamicviewer/",
              ) && this.state.isModelLoading ? (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(255,255,255,0.92)",
                    zIndex: 4,
                  }}
                >
                  <div
                    style={{
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      border: "5px solid rgba(46,163,224,0.22)",
                      borderTopColor: "#2ea3e0",
                      animation: "actuality-map-spin 0.8s linear infinite",
                    }}
                  />
                </div>
              ) : null}
            </div>
          )}
          <style>
            {`
              @keyframes actuality-map-spin {
                from { transform: rotate(0deg); }
                to { transform: rotate(360deg); }
              }
            `}
          </style>
          {isLocationMapViewer() ? (
            <div
              className="callToAction"
              style={{
                position: "absolute",
                top: 12,
                left: 12,
                width: "auto",
                height: "auto",
                minHeight: 0,
                zIndex: 2147483647,
                margin: 0,
              }}
            >
              <h5
                className="prd"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  lineHeight: "normal",
                  padding: "14px 16px",
                  paddingLeft: "16px",
                  margin: 0,
                  whiteSpace: "nowrap",
                }}
                onClick={() => {
                  this.props.openLink();
                  this.setState({ count: this.state.count + 1 }, () => {
                    this.props.updateMobilePayload(this.state);
                  });
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "#000",
                    flexShrink: 0,
                  }}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 18L9 12L15 6"
                      stroke="currentColor"
                      strokeWidth="2.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <Typography
                  className="buyNow"
                  style={{ paddingTop: 0, lineHeight: 1.1 }}
                >
                  {props.UrlTitle ? props.UrlTitle : "Back to map"}
                </Typography>
              </h5>
            </div>
          ) : this.state.showHotspot.isTrue ? null : (
            <div className="callToAction" style={{ top: 0 }}>
              <h5
                className="prd"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  lineHeight: "80px",
                  paddingTop: "25px",
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    color: "#000",
                  }}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15 18L9 12L15 6"
                      stroke="currentColor"
                      strokeWidth="2.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <Typography
                  className="buyNow"
                  style={{ paddingTop: "0px" }}
                  onClick={() => {
                    this.props.openLink();
                    this.setState({ count: this.state.count + 1 }, () => {
                      this.props.updateMobilePayload(this.state);
                    });
                  }}
                >
                  {props.UrlTitle ? props.UrlTitle : "Back to map"}
                </Typography>
              </h5>
            </div>
          )}
          {this.props.productLogo ? (
            <div
              className="modelCompanyLogo"
              style={{
                width: 79,
                height: 79,
                top: 10,
                position: "absolute",
                border: "0px solid red",
                left: 10,
              }}
            >
              <img
                src={API.imgUrl + this.props.productLogo}
                alt=""
                style={{
                  width: 79,
                  height: 79,
                  borderRadius: 8,
                }}
              />
            </div>
          ) : (
            ""
          )}
          {combination.variant?._id ? null : (
            <VariantComponents
              variantControllerHeight={variantControllerHeight}
              Component={this.props.Component}
              selectMaterial={this.props.selectMaterial}
              checkSelected={this.props.checkSelected}
            />
          )}

          <div
            className="poweredBy"
            style={{
              backgroundColor: "#fff",
              width: "100%",
            }}
          >
            <a
              href="https://feelxr.co/"
              target="_blank"
              style={{
                textDecoration: "none",
                color: "#000000",
              }}
            >
              powered by <b style={{ color: "#000" }}>actuality.live</b>
            </a>
          </div>
          {this.state.toggle ? (
            <>
              <div
                className="sideBar"
                style={{
                  overflowX: "hidden",
                  left: isLocationMapViewer() ? 0 : undefined,
                  right: isLocationMapViewer() ? undefined : 0,
                }}
              >
                {isLocationMapViewer() ? (
                  <>
                    <div className="callToAction" style={{ top: 0 }}>
                      <h5
                        className="prd"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          lineHeight: "80px",
                          paddingTop: "25px",
                        }}
                      >
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            color: "#000",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15 18L9 12L15 6"
                              stroke="currentColor"
                              strokeWidth="2.4"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                        <Typography
                          className="buyNow"
                          style={{ paddingTop: "0px" }}
                          onClick={() => {
                            this.props.openLink();
                            this.setState(
                              { count: this.state.count + 1 },
                              () => {
                                this.props.updateMobilePayload(this.state);
                              },
                            );
                          }}
                        >
                          {props.UrlTitle ? props.UrlTitle : "Back to map"}
                        </Typography>
                      </h5>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="productName">
                      <div
                        className="closeToggle"
                        style={{
                          overflowX: "hidden",
                          cursor: "pointer",
                          zIndex: "99999",
                        }}
                        onClick={() =>
                          this.setState(
                            {
                              toggle: false,
                            },
                            () => {
                              // console.log(this.state.toggle);
                            },
                          )
                        }
                      >
                        <img src={closeIcon} style={{ width: "16px" }} />
                      </div>
                      <h5 className="prd1">
                        <Typography
                          className="buyNow"
                          style={{ paddingTop: 0 }}
                        >
                          {props.product ? props.product : ""}
                          <br />
                        </Typography>
                        <Typography>
                          {props.productSubTitle ? props.productSubTitle : ""}
                          <br />
                        </Typography>
                      </h5>
                    </div>

                    {this.props.visibility ? (
                      <>
                        <div className="callToAction">
                          <h5 className="prd">
                            <Typography
                              className="buyNow"
                              style={{ paddingTop: "25px" }}
                              onClick={() => {
                                this.props.openLink();
                                this.setState(
                                  { count: this.state.count + 1 },
                                  () => {
                                    this.props.updateMobilePayload(this.state);
                                  },
                                );
                              }}
                            >
                              {props.UrlTitle ? props.UrlTitle : "Buy Now"}
                              <br />
                            </Typography>
                            <Typography
                              onClick={() => {
                                this.props.updateMobilePayload(this.state);
                                this.props.openLink();
                              }}
                            >
                              {props.UrlDescription ? props.UrlDescription : ""}
                              <br />
                            </Typography>
                          </h5>
                        </div>
                      </>
                    ) : (
                      <div
                        style={{
                          width: "100%",
                          height: 10,
                        }}
                      />
                    )}
                  </>
                )}
              </div>
            </>
          ) : (
            ""
          )}
          {props.showARError && (
            <div id="error">
              <div
                style={{
                  backgroundColor: "#ffffffdd",
                  borderRadius: "16px",
                  paddingTop: "35px",
                  padding: "16px",
                  position: "fixed",
                  // left: "55px",
                  left: "50%",

                  // top: "250px",
                  top: "50%",
                  zIndex: 9999,
                  height: "100px",
                  width: "250px",
                  boxShadow: "0 4px 4px rgba(0, 0, 0, 0.25)",
                  paddingLeft: "15px",
                  fontFamily: "Inter",
                  transform: "translateX(-50%) translateY(-50%) ",
                  border: "0px solid red",
                }}
              >
                <p style={{ color: "#000", paddingLeft: "18px" }}>
                  <img
                    src={closeModal}
                    alt=""
                    style={{
                      width: 20,
                      height: 20,
                      position: "absolute",
                      right: 10,
                      top: 10,
                      fontSize: 20,
                    }}
                    onClick={() => {
                      this.setState({ showARError: false });
                      window.location.reload();
                    }}
                  />
                  Hey! It looks like your device doesn't support AR. Please{" "}
                  <a
                    href="https://arcade.ltd/is-my-device-ar-compatible/"
                    target={"_blank"}
                    style={{ color: "#000" }}
                  >
                    CLICK HERE
                  </a>{" "}
                  to check the supported device list.
                </p>
              </div>
              {/* </Modal> */}
            </div>
          )}
        </div>
        // </Beforeunload>
      );
    }
  }
}
const Lorem = () => (
  <>
    <h1>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. At sed libero
      officia excepturi optio porro nobis animi vero quae minus, deserunt
      perspiciatis autem obcaecati placeat et magni possimus, ex ad!
    </h1>
    <br />
  </>
);
